import { QueryHookOptions } from '@apollo/react-hooks';
import { OperationVariables } from 'apollo-client';
import { DocumentNode } from 'graphql';
import usePgeQuery from '../usePgeQuery';
import useInvoicePaymentAuth from './useInvoicePaymentAuth';
import useUtil from './useUtil';

export default function useAuthQuery<
  TData = any,
  TVariables = OperationVariables
>(query: DocumentNode, options: QueryHookOptions<TData, TVariables> = {}) {
  const { isAuthenticated } = useInvoicePaymentAuth();
  const { setErrorNotification } = useUtil();
  return usePgeQuery<TData, TVariables>(query, {
    ...options,
    onError: () => setErrorNotification(true),
    context: {
      invoicePayment: true
    },
    skip: !isAuthenticated || options.skip,
  });
}
